import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">WV Beautician · Your Beauty Destination</p>
        <h1>Transform Your Look with WV Beautician</h1>
        <p className="lede">
          Discover a world of beauty services tailored just for you. From hair styling to skincare, our expert beauticians are here to enhance your natural beauty.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/about" target="_self" className="secondary">
            Meet Our Team
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Expert Services</h2>
          <p>
            Our skilled beauticians offer a range of services, including haircuts, coloring, makeup application, and more, ensuring you look and feel your best.
          </p>
        </article>
        <article>
          <h2>Personalized Experience</h2>
          <p>
            We believe in a personalized approach. Our team takes the time to understand your unique style and preferences, delivering results that exceed your expectations.
          </p>
        </article>
        <article>
          <h2>Book Your Appointment</h2>
          <p>
            Ready for a makeover? Schedule your appointment today and let us help you shine with confidence.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;